<style scoped lang="scss">
// 为了适配一级菜单添加了get apps 的菜单栏 宽度不够
  header{
    background: #fff;
    border-bottom: 1px solid #eee;
    z-index: 999;
    top:0;
    left:0;
    right:0;
    position: fixed;
    .head_icon{
      width: 30px!important;
      border-radius: 50%;
    }
    /* 显示隐藏 */
    .order-show {
      width: 40%;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #f6665d;
    }
    .order-show-pic {
      margin: 10px;
      width: 14px;
      height: 14px;
    }
    .icons{
      background: none!important;
    }
    .oder-show-content{
      cursor: pointer;
      display: block;
      border: 1px solid #9EA7B4;
      width: 100px;
      height: 100px;
      border-radius: 20px;
      margin-top: 5px;
      background: #00a0e9;
      color: #fff;
    }
    .h-con{
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .h-con.container{
      min-width:1300px;
    }
    .logo{
      margin-right:20px;
      cursor: pointer;
      img{
        width:125px;
      }
    }
    .top-right{
    //  width: 51%;
      display: flex;
      align-items: center;
      .search-box{
        border-radius: 4px;
        overflow: hidden;
        display: flex;
        align-items: center;
        margin-right: 20px;
      }
      input{
        background: #F9F9F9;
        height:30px;
        line-height: 30px;
        padding:0 10px;
        border-radius: 4px 0 0 4px;
        border:1px solid #ddd;
        border-right: 0;
        width: 100px;
      }
      .btn-search{
        height:30px;
        background: #014492;
        img{
          height: 30px;
        }
      }
      .icon{
        width:30px;
        height:30px;
        text-align: center;
        padding-top:5px;
        border-radius: 50%;
        background: #EFF5FF;
        margin-right:8px;
        img{
          width:20px;
        }
      }
    }
    .en-link-icon{
      display: flex;
      position: relative;
      top:2px;
      margin-right: 15px;
      img{
        width: 24px;
        //height: 30px;
      }
    }
  }
  .container{
    position: relative;
    //width: 65%;

  }
  .sub-menu dd{
    max-height:200px !important;
  }
  .sub-menu1 dd{
    width:420px
  }
  .dd-element-box{
    flex:60%;
    color:#868788;
    height:calc(100% + 5px);
    overflow-y:auto;

  }
  .head-fixed{
    position: fixed;
    top:0;
    left:0;
    width:100%;
    z-index: 99;
    background: #fff;
  }
  .second-title {
    color:#333;
    font-weight:bold;
    font-size:15px;
    padding: 10px 0 0 5px;
    border-left: 3px solid #F2F3F4;
    cursor: pointer;
  }
  .first-title {
    border-left: 3px solid #F2F3F4;
    padding-left:10px;
  }
  .a {
    display: flex;
    // color:#9B9C9D;
    color:#333;
    padding:10px 0 10px 25px;
    border-left: 3px solid #F2F3F4;
    //padding-left:25px
  }
  .hover-bold:hover{
     font-weight: bold !important;
  }
@media screen and (max-width: 1440px){
  .container{
    position: relative;
   // width: 1250px!important;
  }
  .top-right{
    width: 51% !important;
  }
}
@media screen and (max-width: 1680px){
  .container{
    position: relative;
   // width: 1250px!important;
  }
  .top-right{
    width: 51% !important;
  }
}
@media screen and (max-width: 1600px){
  .container{
    position: relative;
   // width: 1250px!important;
  }
  .top-right{
    width: 51% !important;
  }
}

</style>
<style lang="scss">
.el-submenu__title {
  padding: 0 10px !important;
}
.el-menu-item {
  padding: 0 5px !important;
}
  .el-menu--horizontal{
    left:0 !important;
    right:0;
    margin-top: 1px;
    background: #fff;
   // width:1250px !important;
    margin: 0 auto;
    .el-menu--popup{
      //width:1250px;
      margin:20px auto 0;
      box-shadow: none;
    }
    .el-submenu .el-submenu__icon-arrow{
      display: none;
    }
  }
  @media screen and (max-width: 1280px){
    .dropdown-menu{
      top: 61px!important;
    }
    .el-menu--horizontal{
      left:0 !important;
      right:0;
      margin-top: 1px;
      background: #fff;
      //width:1250px !important;
      margin: 0 auto;
      .el-menu--popup{
        //width:1250px;
        margin:20px auto 0;
        box-shadow: none;
      }
      .el-submenu .el-submenu__icon-arrow{
        display: none;
      }
    }
  }
  @media screen and (max-width: 1366px) and (min-width: 1360px){
    .dropdown-menu{
      top: 61px!important;
    }
  }
  .head-fixed{
    .el-menu--horizontal{
      top:auto !important;
    }
  }
  .el-menu.el-menu--horizontal{
    border-bottom:0;
  }
  .el-menu--horizontal>.el-menu-item{
    text-align: center;
    margin-right: 10px;
    &:hover{
      color:#014492 !important;
      font-weight: bold;
    }
  }
  @media screen and (max-width: 1440px){
    .el-menu--horizontal>.el-menu-item{
      text-align: center;
      margin-right: 10px;
      &:hover{
        color:#014492 !important;
        font-weight: bold;
      }
    }
  }
  @media screen and (max-width: 1680px){
    .el-menu--horizontal>.el-menu-item{
      text-align: center;
      margin-right: 10px;
      &:hover{
        color:#014492 !important;
        font-weight: bold;
      }
    }
  }
  @media screen and (max-width: 1600px){
    .el-menu--horizontal>.el-menu-item{
      text-align: center;
      margin-right: 10px;
      &:hover{
        color:#014492 !important;
        font-weight: bold;
      }
    }
  }
  .el-menu--horizontal>.el-menu-item.is-active{
    border-bottom: 4px solid #014492;
    font-weight: bold;
    background: #EFF5FF !important;
  }
  .el-menu--horizontal .el-menu .el-menu-item.is-active{
    font-weight: bold;
  }
  .sub-menu-level-1{
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
    margin-bottom: 20px;
    dd{
      display: flex;
      justify-content: start;
      flex-direction: row;
      .sub-title{
        font-weight: bold;
        color: #19193A;
        width:160px;
        font-size: 16px;
        margin-left: 10px;
        line-height: 40px;
        text-align: center;
        // border-right: 1px solid #eee;
      }
      .sub-title:before {
        color: #19193A;
        font-size: 25px;
        content:' · ';
        font-weight: bold;
      }
      .sub-menu-level-2{
        max-width: 1000px;
        display: flex;
        flex-wrap: wrap;
        border-left: 2px solid #bcbec2;
        padding-left: 50px;
        li{
          width: 180px;
          border-left: none;
        }
      }
    }

    //.sub-title a{
    //  color: #333333!important;
    //}
  }


  .sub-menu{
    display: flex;
    width: 100%;
    flex-direction: column;
    flex-wrap: wrap;
    height: 525px;
    dd{
      width:350px;
      margin-right: 50px;
      margin-bottom: 50px;
      display: flex;
    }
    .sub-title{
      font-weight: bold;
      color: #19193A;
      // width:150px;
      font-size: 16px;
      padding: 10px;
      border-radius: 10%;
      // border-right: 1px solid #eee;
    }
    //.sub-title a{
    //  color: #333333!important;
    //}
    .sub-title:before {
      color: #19193A;
      font-size: 25px;
      content:' · ';
      font-weight: bold;
    }
  }
  .el-menu--horizontal .el-menu .el-menu-item{
    padding:0;
    &:hover{
      color:#014492 !important;
      font-weight: bold;
    }
  }
  .el-menu--horizontal .el-menu .el-menu-item a:hover{
    color:#014492 !important;
    font-weight: bold;
  }
  .username{
    max-width: 50px;
    min-width: 0;
    flex:1;
    position: relative;
    &:hover::after{
      content:attr("title");
      position: absolute;
      white-space: nowrap;
      visibility: hidden;
      pointer-events: none;
      border-radius: 4px;
      padding: 5px 10px;
      background-color: #333;
      color: #fff;
      text-align: center;
    }
  }
  .username.text-ellipsis{
    white-space: nowrap;
  }
  .el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
    color:#014492;
    font-weight: bold;
    border-bottom: 4px solid #014492;
    background: #EFF5FF !important;
  }
  .el-menu--horizontal>.el-submenu.is-opened .el-submenu__title{
    color:#014492 !important;
    font-weight: bold;
    // background: #014492;
    // color: #fff !important;
  }
  .popper__arrow{
    margin-left: -12px;
  }
  .mask{
    position: fixed;
    top:61px;
    left:0;
    right:0;
    bottom:0;
    z-index: 21;
    background: rgba(0,0,0,.5);
  }
  .dropdown-menu{
    box-shadow: 0 5px 8px rgba(0,0,0,.1);
  }
  .cloud-platform{
    margin-right: 8px;
    min-width:45px;
    cursor: pointer;

  }
</style>
<template>
  <div>
    <div style="height:60px;"></div>
    <header>
      <div class="container h-con">
        <div class="logo" @click="$router.push('/')"><img src="@/assets/images/logo.png"></div>
        <el-menu ref="menuRef" :default-active="defaultActive" class="el-menu-vertical-demo" :router="true" :unique-opened="false" text-color="#333333" active-text-color="#014492" mode="horizontal">
          <!--首页-->
          <component v-for="(item, index) in pageDataNew.menu"  :index="item.to" :key="index+'menu'" :is="item.subMenu ? 'el-submenu' : 'el-menu-item'" popper-class="dropdown-menu">
            <template slot="title">
              <span >{{item.label}}</span>
            </template>
            <template v-if="item.subMenu">
              <dl class="sub-menu" v-if="item.subMenu">
                <dd v-for="(itx, idx) in item.subMenu" :key="idx+'menu'">
                  <div class="sub-title">{{itx.label}}</div>
                  <el-menu-item :index="it.to" v-for="(it, i) in itx.children" :key="i+'menu'" v-show="!it.disabled">{{it.label}}</el-menu-item>
                </dd>
              </dl>
            </template>
          </component>
          <!--产品服务-->
          <component v-for="(item, index) in pageDataNew.products" :index="item.to" :key="index+'products'" :is="item.subMenu ? 'el-submenu' : 'el-menu-item'" popper-class="dropdown-menu">
            <template slot="title">
              <el-menu-item :index="item.to" style="display: contents">
                <a  :href="item.to" style="color: #333333" v-if="!item.ref">{{item.label}}</a>
              </el-menu-item>
            </template>
            <template v-if="item.subMenu">
              <dl class="sub-menu" v-if="item.subMenu">
                <template v-for="(itx, idx) in item.subMenu" >
                  <dd :key="idx+'productsOne'">
                    <div class="sub-title" style="flex:40%;" >
                      <el-menu-item :index="itx.to ? itx.to : itx.noHref" style="display: contents">
                        <span v-if="itx.noHref" style="padding-left:10px;color: #333;;margin-left: -10px;position: relative;top: -5px">{{itx.label}}</span>
                        <a v-else :href="itx.to" style="padding-left:10px;color: #333;;margin-left: -10px;position: relative;top: -5px">{{itx.label}}</a>
                      </el-menu-item>
                    </div>
                    <div class="dd-element-box" v-if="!itx.noLeaf">
                      <template v-for="(it, i) in itx.children">
                        <template v-if="it.children">
                          <div :key="i+'productsThree'">
                            <div @click="getClickList(it.label);showContent=!showContent" >
                              <i :class="it.label===title && showContent === true?'el-icon-caret-bottom':'el-icon-caret-right'"></i>
                              <el-menu-item :index="it.to ? it.to : it.label" style="display: contents">
                                <a v-if="it.to" :href="it.to" style="color: #333;">{{it.label}}</a>
                                <span v-else @click.stop="getClickList(it.label);showContent=!showContent" style="color: #333;">{{it.label}}</span>
                              </el-menu-item>
                            </div>
                            <div v-show="it.label===title && showContent === true">
                              <el-menu-item v-for="(its, j) in it.children" v-show="it.label===title" :key="j+'productsFour'" :index="its.to ? its.to : its.label"  class="first-title">
                                <a  v-if="!its.ref" :href="its.to" style="padding-left:10px;color: #333;">{{its.label}}</a>
                                <span  v-else-if="!its.to" style="margin-left: 10px;color: #333">{{its.label}}</span>
                              </el-menu-item>
                            </div>
                          </div>
                        </template>
                        <template v-else>
                          <el-menu-item class="first-title" :index="it.to ? it.to : it.ref ? it.ref : it.label" :key="i+'productsTwo'" >
                            <a  :href="it.to" style="padding-left:10px;color: #333;" v-if="!it.ref">{{it.label}}</a>
                            <a  v-else-if="it.ref" :href="it.ref" style="margin-left: 10px;color: #333">{{it.label}}</a>
                            <span  v-else-if="!it.to" style="margin-left: 10px;color: #333">{{it.label}}</span>
                          </el-menu-item>
                        </template>
                      </template>
                    </div>
                  </dd>
                </template>
              </dl>
            </template>
          </component>
           <!--设备原料-->
          <component v-for="(item, index) in pageDataNew.equipment" :index="item.to"  :key="index+'equipment'" :is="item.subMenu ? 'el-submenu' : 'el-menu-item'" popper-class="dropdown-menu">
            <template slot="title">
              <el-menu-item :index="item.to" style="display: contents;">
                <a :href="item.to" style="color: #333333">{{item.label}}</a>
              </el-menu-item>
            </template>
            <template v-if="item.subMenu">
              <dl class="sub-menu sub-menu1" v-if="item.subMenu">
                <template v-for="(itx, idx) in item.subMenu">
                  <dd :key="idx+'molecularReagent'" v-if="idx==0 && molecularReagentMenu[0] && molecularReagentMenu[0].subMenu">
                    <div class="sub-title" style="flex:40%;">
                      <el-menu-item :index="'/molecular-reagent'" style="display: contents;">
                        <a  :href="'/molecular-reagent'" style="padding-left:10px;color: #333;;margin-left: -10px;position: relative;top: -5px">生物试剂</a>
                      </el-menu-item>
                    </div>
                    <div class="dd-element-box">
                      <el-menu-item :index="it.to ? it.to : it.ref" v-for="(it, i) in molecularReagentMenu[0].subMenu" :key="i+'molecularReagentTwo'" v-show="!it.children" class="first-title">
                        <a  :href="it.to" class="hover-bold" :style="`padding-left:10px;color:#333; font-weight:${$route.query.name == it.label?'600':'500'}`" v-if="!it.ref">{{it.label}}</a>
                        <a  v-else-if="it.ref" :href="it.ref" style="margin-left: 10px;color: #333">{{it.label}}</a>
                      </el-menu-item>
                    </div>
                  </dd>
                  <dd  :key="idx+'equipmentOne'">
                  <div class="sub-title" style="flex:40%;">
                    <el-menu-item :index="itx.to ? itx.to : itx.ref ? itx.ref : itx.label" style="display: contents;">
                      <a :href="itx.ref" style="padding-left:10px;color: #333333;margin-left: -10px;position: relative;top: -5px" v-if="itx.ref">{{itx.label}}</a>
                      <a :href="itx.to" style="padding-left:10px;color: #333;margin-left: -10px;position: relative;top: -5px" v-if="itx.to">{{itx.label}}</a>
                      <span style="padding-left:10px;color: #333;margin-left: -10px;position: relative;top: -5px" v-else>{{itx.label}}</span>
                    </el-menu-item>
                  </div>
                  <div class="dd-element-box">
                      <!--显示二级标题  -->
                      <el-menu-item :index="it.to ? it.to : it.ref ? it.ref : it.label" v-for="(it, i) in itx.children" :key="i+'equipmentTwo'" v-show="!it.children" class="first-title">
                        <a  :href="it.to" style="padding-left:10px;color: #333" v-if="it.to">{{it.label}}</a>
                        <a  v-else-if="it.ref" :href="it.ref" style="margin-left: 10px;color: #333">{{it.label}}</a>
                        <span  v-else style="margin-left: 10px;color: #333">{{it.label}}</span>

                      </el-menu-item>
                      <!--显示三级标题  -->
                      <div v-show="it.children" v-for="(it, i) in itx.children" :key="i+'equipmentThree'">
                        <div  @click="getClickList(it.label);showContent=!showContent" style="height:30px; line-height: 30px" >
                          <i :class="it.label===title && showContent === true?'el-icon-caret-bottom':'el-icon-caret-right'"></i>
                          <el-menu-item :index="it.to" style="display: contents">
                            <a  :href="it.to" style="color: #333;">{{it.label}}</a>
                          </el-menu-item>
                        </div>
                        <div v-if="showContent">
                          <el-menu-item :index="its.to ? its.to : its.ref ? its.ref : its.label" v-for="(its, i) in it.children" v-show="it.label===title" :key="i+'equipmentFour'"  style="" class="a first-title">
<!--                            <span slot="title" style="padding-left:10px">{{its.label}}</span>-->
                            <a  :href="its.to" style="padding-left:10px;color: #333;" v-if="!its.ref">{{its.label}}</a>
                            <a  v-else-if="its.ref" :href="its.ref" style="margin-left: 10px;color: #333;">{{its.label}}</a>
                            <span  v-else-if="!its.to" style="margin-left: 10px;color: #333;">{{its.label}}</span>
                          </el-menu-item>
<!--                          <a href="" v-for="(its, i) in it.children" v-show="it.label===title" :key="i+'equipmentFour'" class="a" style="">{{its.label}}</a>-->
                        </div>
                      </div>
                  </div>
                  </dd>

                </template>

              </dl>
            </template>
          </component>
          <component v-for="(item, index) in pageDataNew.biology"  :index="item.to" :key="index+'biology'" :is="item.subMenu ? 'el-submenu' : 'el-menu-item'" popper-class="dropdown-menu">
            <template slot="title">
              <span >{{item.label}}</span>
            </template>
            <template v-if="item.subMenu">
              <dl class="sub-menu" v-if="item.subMenu">
                <dd v-for="(itx, idx) in item.subMenu" :key="idx+'biologyOne'">
                  <div class="sub-title">{{itx.label}}</div>
                  <el-menu-item :index="it.to" v-for="(it, i) in itx.children" :key="i+'biologyTwo'" v-show="!it.disabled">{{it.label}}</el-menu-item>
                </dd>
              </dl>
            </template>
          </component>
          <!--生物制造-->
          <component v-for="(item, index) in pageDataNew.geneFactory"  :index="item.to" :key="index+'geneFactory'" :is="item.subMenu ? 'el-submenu' : 'el-menu-item'" popper-class="dropdown-menu">
            <template slot="title">
              <span >{{item.label}}</span>
            </template>
            <template v-if="item.subMenu">
              <dl class="sub-menu" v-if="item.subMenu">
                <dd v-for="(itx, idx) in item.subMenu" :key="idx+'geneFactoryOne'">
                  <div class="sub-title">{{itx.label}}</div>
                  <el-menu-item :index="it.to" v-for="(it, i) in itx.children" :key="i+'geneFactoryTwo'" v-show="!it.disabled">{{it.label}}</el-menu-item>
                </dd>
              </dl>
            </template>
          </component>
          <!--资源中心-->
          <component v-for="(item, index) in pageDataNew.resource"  :index="item.to" :key="index+'resource'" :is="item.subMenu ? 'el-submenu' : 'el-menu-item'" popper-class="dropdown-menu">
            <template slot="title">
              <span >{{item.label}}</span>
            </template>
            <template v-if="item.subMenu">
              <dl class="sub-menu" v-if="item.subMenu" style="flex-direction: row;flex-wrap: nowrap;">
                <dd v-for="(itx, idx) in item.subMenu" :key="idx+'resourceOne'">
                  <div class="sub-title">{{itx.label}}</div>
                  <el-menu-item :index="it.to" v-for="(it, i) in itx.children" :key="i+'resourceTwo'" v-show="!it.disabled">{{it.label}}</el-menu-item>
                </dd>
              </dl>
            </template>
          </component>
          <!--擎科概况-->
          <component v-for="(item, index) in pageDataNew.summary"  :index="item.to" :key="index+'summary'" :is="item.subMenu ? 'el-submenu' : 'el-menu-item'" popper-class="dropdown-menu">
            <template slot="title">
              <span >{{item.label}}</span>
            </template>
            <template v-if="item.subMenu">
              <dl class="sub-menu" v-if="item.subMenu" style="flex-direction: row;flex-wrap: nowrap;">
                <dd v-for="(itx, idx) in item.subMenu" :key="idx+'summaryOne'">
                  <div class="sub-title" style="flex:40%;">{{itx.label}}</div>
                  <div style="flex:60%;color:#868788;">
                      <!--显示二级标题  -->
                      <el-menu-item :index="it.to" v-for="(it, i) in itx.children" :key="i+'summaryTwo'" v-show="!it.children" class="first-title">
                        <a  :href="it.to" style="padding-left:10px;color: #333;">{{it.label}}</a>
                      </el-menu-item>
                      <!--显示三级标题  -->
                      <div v-show="it.children" v-for="(it, i) in itx.children" :key="i+'summaryThree'">
                        <div class="second-title" @click="getClickList(it.label);showContent=!showContent" >
                          <i :class="it.label===title && showContent === true?'el-icon-caret-bottom':'el-icon-caret-right'"></i>
                          {{it.label}}
                        </div>
                        <div v-if="it.label===title && showContent === true">
                          <a href="" v-for="(its, i) in it.children" :key="i+'summaryFour'" class="a" style="">{{its.label}}</a>
                        </div>
                      </div>
                  </div>
                </dd>
              </dl>
            </template>
          </component>
          <!--商城-->
          <component v-for="(item, index) in pageDataNew.kbb" :index="item.ref" :key="index+'kbb'" :is="item.subMenu ? 'el-submenu' : 'el-menu-item'" popper-class="dropdown-menu">
            <template slot="title">
              <a  :href="item.ref" style="color: #333333" target="_blank">{{item.label}}</a>
            </template>
            <template v-if="item.subMenu">
              <dl class="sub-menu" v-if="item.subMenu" style="flex-direction: row;flex-wrap: nowrap;">
                <dd v-for="(itx, idx) in item.subMenu" :key="idx+'kbbOne'">
                  <div class="sub-title">{{itx.label}}</div>
                  <el-menu-item :index="it.to" v-for="(it, i) in itx.children" :key="i+'kbbTwo'" v-show="!it.disabled">{{it.label}}</el-menu-item>
                </dd>
              </dl>
            </template>
          </component>
          <!-- 云工具 -->
          <el-menu-item @click="goCloudTools" index="/tools" key="toolsIndex"><span>云工具</span></el-menu-item>
        </el-menu>
        <div class="top-right">
          <div class="cloud-platform" @click="goCloudPlatform">云分析</div>
          <div class="search-box">
            <input type="text" v-model="keywords"/>
            <span class="btn-search pointer" @click="bindSearch"><img src="@/assets/images/icon_search.png"> </span>
          </div>
          <div class="en-link-icon"><a href="https://www.tsingke.com" target="_blank"><img src="@/assets/images/enLinkIcon.png" title="去英文官网"></a></div>
          <div class="d-flex flex-align-center mr10 pointer" @click="login" v-if="!memberInfo" style="font-size:12px">
            <div class="icon">
              <img src="@/assets/images/icon_user.png">
            </div>请登录
          </div>
          <div class="d-flex flex-align-center mr10 pointer" v-else>
            <div class="icon"><img src="@/assets/images/icon_user.png"></div>
            <el-dropdown trigger="click">
            <span class="el-dropdown-link d-flex flex-align-center">
              <div class="username text-ellipsis" :title="memberInfo.realName | stateFormat(memberInfo.realName)">{{memberInfo.realName | stateFormat(memberInfo.realName)}}</div><i class="el-icon-arrow-down el-icon--right"></i>
            </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="$router.push('/user')">个人中心</el-dropdown-item>
                <el-dropdown-item @click.native="loginOut">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <el-badge :value="cartNums" class="item" :hidden="cartNums === 0">
            <div class="icon pointer fl" style="margin-right: 0;" ><img src="@/assets/images/icon_chart.png"></div>
            <el-dropdown trigger="click" style="margin-top: 5px;margin-left: 2px;">
            <span class="el-dropdown-link d-flex flex-align-center">
              <div class="username text-ellipsis" style="font-size:12px">订购</div><i class="el-icon-arrow-down el-icon--right"></i>
            </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="orderBuy('primer')">在线订购（引物合成）</el-dropdown-item>
                <el-dropdown-item @click.native="orderBuy('gene')">在线订购（基因合成）</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-badge>
        </div>
      </div>
      <div class="mask" v-show="showMask"></div>
    </header>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import 'babel-polyfill'
import myUpload from 'vue-image-crop-upload'
import { carts, newsColumns, productCategories, getAuthCode } from '@/services/api.index'
import _ from 'lodash'
import { blacklistsCheck } from '@/services/api.index'

export default {
  components: {
    myUpload
  },
  name: 'qk-header',
  data () {
    return {
      memberInfo: this.baseMethods.getLocalObj('memberInfo'),
      cartNums: 0,
      avatar: require('../assets/images/icon_user.png'),  //用于存储剪切完图片的base64Data和显示回调图片
      showtime: false,  //剪切框显示和隐藏的flag
      size:2.1,
      keywords: '',
      headFixed: false,
      showMask: false,
      isShow:'',
      brandFold: true,
      icons:"",
      head_icon:"",
      title: '合成配套设备',
      showContent: false,
      molecularReagentMenu: [],
    }
  },
  filters: {
    stateFormat(stateId) {
      if(stateId){
        return stateId.substring(0,3)
      }
    }
  },
  watch: {
    title: {
      immediate: true,
      handler(data) {
        console.log('data',data)
        this.showContent = true
      }
    },
    $route (to, from) {
      // if(to.path === '/user' || to.path === '/') {
      //   this.memberInfo = this.baseMethods.getLocalObj('memberInfo')
      // }
      console.log("this.baseMethods.getLocalObj('memberInfo')",this.baseMethods.getLocalObj('memberInfo'))
      this.memberInfo = this.baseMethods.getLocalObj('memberInfo')
    }
  },
  created() {
    // if(this.$route.path == '/qq_conn/101972422' || this.$route.path == '/app/') {
    //   // 创建a标签
    //   let link = document.createElement('a')
    //   // href链接
    //   link.setAttribute('href', 'https://tsingke-oss.oss-cn-beijing.aliyuncs.com/prod/appid/apple-app-site-association')//https://tsingke-oss.oss-cn-beijing.aliyuncs.com/prod/apple-app-site-association
    //   // 自执行点击事件
    //   link.click()
    // }

    const outPaths = ['/register', '/account_status', '/reset', '/app/', '/app/apple-app-site-association', '/qq_conn/101972422/apple-app-site-association']
    const path = this.$route.path
    if (!outPaths.includes(path) && this.baseMethods.getLocalObj('userInfo')) {
      console.log(111,this.baseMethods.getLocalObj('userInfo'))
      this.getCartInfo()
    }
    this.getNewsTabs()
    this.getCategories()
    document.addEventListener("visibilitychange", () => {
      if (!document.hidden) {
        this.memberInfo = this.baseMethods.getLocalObj('memberInfo')
      }
    });
  },
  mounted() {
    this.getMolecularCategories()
  },
  computed: {
    ...mapState(['pageDataNew']),
    defaultActive () {
      console.info('URL ACTIVATE', decodeURIComponent(this.$route.fullPath))
      const goodsId = this.$route.params.id
      let path = ''
      switch (this.$route.path) {
        case '/molecular-reagent':
          path = this.$route.path
          break;
        case '/search':
          path = '/molecular-reagent'
          break;
        case `/products/details/${goodsId}`:
          path = '/molecular-reagent'
          break;
        default:
          path = this.$route.fullPath
          break;
      }
      if(this.$route.path.includes("/tools")){
        path = "/tools"
      }
      console.log("defaultActive", path)
      return decodeURIComponent(path)
    }
  },
  methods: {
    goCloudTools(){
      if(!this.baseMethods.getLocalObj('userInfo')) {
        const meta= this.$route.meta
        window.open(decodeURIComponent(process.env.SHOP_URL + "member/login?redirectUrlTs=/tools"))
        this.$refs.menuRef.defaultActive = this.$route.path
        this.$refs.menuRef.activeIndex = this.$route.path
        if(meta.content && meta.content.title) {
          document.title = meta.content.title;
        } else if (meta.title) {
          document.title = meta.title;
        }
      }
    },
    goCloudPlatform(){
      if(this.baseMethods.getLocalObj('userInfo')) {
        getAuthCode().then((res)=>{
          window.open(`https://cloud.tsingke.com.cn?app_id=tsingke_official&auth_code=${res.data}`, '_blank');
        })
      }else {
        window.open( decodeURIComponent(process.env.SHOP_URL + 'member/login?redirectUrlTs=https://cloud.tsingke.com.cn?app_id=tsingke_official'))
      }
    },
    //剪切成功后的回调函数
    cropSuccess(imgDataUrl) {
      //  imgDataUrl其实就是图片的base64data码
      this.avatar = imgDataUrl;
      this.icons = "icons";
      this.head_icon = "head_icon";
      console.log(imgDataUrl)//这里打印出来的是base64格式的资源
    },
    getCartInfo () {
      carts().then(res => {
        res.data.map(item => {
          this.cartNums += item.quantity
        })
      })
    },
    // 购物车
    toCharts () {
      this.$router.push('/products/chart')
    },
    // 获取新闻栏目
    async getNewsTabs () {
      if (this.pageDataNew.summary[0].subMenu[1].children.length > 0) return
      let newsMenu = []
      await newsColumns().then(res => {
        res.data.map((item, index) => {
          newsMenu.push({name: item.name, to: `/news?id=${item.id}&current=${index}`})
        })
      })
      this.pageDataNew.summary.map(item => {
        if (item.name === '擎科概况') {
          item.subMenu.map(itx => {
            if (itx.name === '新闻') {
              // itx.children = []
              itx.children = itx.children.concat(newsMenu)
            }
          })
        }
      })
    },
    async getMolecularCategories() {
      this.molecularReagentMenu = _.cloneDeep(this.pageDataNew.molecularReagent)
      this.molecularReagentMenu[0].subMenu = []
      const that = this
      productCategories('', 1).then((res) => {
        console.info('MOLECULAR CATE.', res)
        res.data.map((item) => {
          // 产品需求，暂时没有判断是否跳商城的flag，如果修改名称这里需同样修改名称（坑）
          if(item.name === '培养基系列') {
            that.molecularReagentMenu[0].subMenu.push({
              label: item.name,
              ref: process.env.SHOP_URL + 'product/list/846?productTagsId=&brandId=154&promotionId=&orderType=&promotionPluginId=&startPrice=&endPrice='
            })
            return
          }
          that.molecularReagentMenu[0].subMenu.push({
            label: item.name,
            to: `/molecular-reagent?id=${item.id}&name=${item.name}`
          })
        })
        console.info('MENU UPDATED.', this.molecularReagentMenu)
      })
    },
    // 获取产品栏目
    async getCategories () {
      // if (this.pageDataNew.menu[2].subMenu) return
      let categories = []
      let childrenLists = []
      let that = this
      await productCategories().then(res => {
        console.info('CATES', res.data)

        res.data.map(item => {
          if (item.canShow) {
            if (item.level === 1) {
              categories.push(item)
            } else {
              childrenLists.push(item)
            }
          }
        })
        categories.map(item => {
          item.children = []
          childrenLists.map(itx => {
            if (itx.level === 2 && itx.parent && itx.parent.id === item.id) {
              itx.to = `/products?name=${itx.name}&id=${itx.id}`
              item.children.push(itx)
            }
          })
          if (item.children.length === 0) {
            item.to = `/products?name=${item.name}&id=${item.id}`
            item.children.push(item)
          }
        })
        // console.log(categories)
        // this.categories = categories
      })
      this.pageDataNew.menu.map(item => {
        if (item.name === '擎科产品') {
          item.subMenu = []
          item.subMenu = item.subMenu.concat(categories)
        }
      })
    },
    //登录
    login(){
      // this.$router.push('/login')
      window.open(process.env.SHOP_URL + "member/login?redirectUrlTs="+ this.$route.path)
    },
    // 退出登录
    loginOut () {
      localStorage.clear()
      this.memberInfo = this.baseMethods.getLocalObj('memberInfo')
      if(this.$route.path !== '/') this.$router.push('/')
    },
    //跳转商城
    shop(){
      this.$router.push('/molecular-reagent')
      // let href = "http://8.130.53.158/";
      // window.open(href, "_blank");
    },
    // 搜索
    bindSearch () {
      this.$router.push(`/search?keywords=${this.keywords}`)
    },
    getClickList (label) {
      this.title = label
    },
    async orderBuy(type) {
      if(this.baseMethods.getLocalObj('userInfo')) {
        const memberInfo = this.baseMethods.getLocalObj('memberInfo');
        const { data } = await blacklistsCheck(memberInfo.id, "PRIMER");
        if(!data)
          return this.$alert('下单异常,请电联4006683730转7','提示',{ confirmButtonText: '确认'});
        if(type === 'primer') {
          this.$router.push('/tec/order_primer')
        }else if(type === 'gene') {
          this.$router.push('/tec/order_gene')
        }
      }else {
        window.location = decodeURIComponent(process.env.SHOP_URL + "member/login?redirectUrlTs=" + this.$route.path)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/header.vue